<template>
  <div class="row">
    <div class="col-lg-12">
      <loading
        loader="dots"
        :height="170"
        :width="170"
        color="#3282b8"
        background-color="#505273"
        transition="fade"
        :active="isLoading"
        :is-full-page="true"
      ></loading>
      <div class="row">
        <div class="col-lg">
          <h4>
            Select Site:
            <br />
            <el-select
              class="select-info tab select-width"
              placeholder="Single Select"
              v-model="selects.site"
              @change="filterSite()"
            >
              <el-option
                v-for="option in selects.sites"
                class="select-info"
                :value="option.value"
                :label="option.label"
                :key="option.label"
              ></el-option>
            </el-select>
          </h4>
        </div>
        <div class="col-lg">
          <h4>
            Select Collector:
            <br />
            <el-select
              class="select-info tab select-width"
              placeholder="Single Select"
              v-model="selects.collector"
              @change="filterCollector()"
            >
              <el-option
                v-for="option in selects.collectors"
                class="select-info"
                :value="option.value"
                :label="option.label"
                :key="option.label"
              ></el-option>
            </el-select>
          </h4>
        </div>
        <div class="col-lg">
          <h4>
            Select Time:
            <br />
            <el-select
              class="select-info tab select-width"
              placeholder="Single Select"
              v-model="selects.time"
              @change="filterTime()"
            >
              <el-option
                v-for="option in selects.times"
                class="select-info"
                :value="option.value"
                :label="option.label"
                :key="option.label"
              ></el-option>
            </el-select>
          </h4>
        </div>
        <div class="col-lg-4">
          <h4>
            Select Date Range :
            <el-date-picker
              v-model="value2"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="To"
              start-placeholder="Start date"
              end-placeholder="End date"
              :picker-options="pickerOptions"
              @change="getDate()"
            ></el-date-picker>
          </h4>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-3 d-flex">
          <!-- Total overall incoming waste tonnage received -->
          <card>
            <template slot="header">
              <h3 class="card-title">
                <i class="tim-icons icon-paper text-info"></i>
                <b>&nbsp;Total Overall Incoming Waste Tonnage Received</b>
              </h3>
            </template>
            <div class="row">
              <div class="col-lg text-center">
                <img src="@/assets/img/tonnage.png" width="50" />
              </div>
            </div>
            <div class="row">
              <div class="col-lg text-center">
                <p style="font-size: 45px">
                  {{ totalOverallIncomingWasteTonnageReceived }}
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-lg text-center">
                <p>MT</p>
              </div>
            </div>
          </card>
        </div>
        <div class="col-lg-9 d-flex">
          <!-- Total sorting of waste collection by collectors based on the following category -->
          <card>
            <template slot="header">
              <h3 class="card-title">
                <i class="tim-icons icon-paper text-info"></i>
                <b
                  >&nbsp;Total Sorting of Waste Collection by Collectors Based
                  On The Following Category</b
                >
              </h3>
            </template>
            <br />
            <div class="row">
              <div class="col-lg text-center">
                <!-- bulky waste -->
                <h1 style="font-size: 45px">
                  {{ bulkywaste }}<span style="font-size: 12px"> MT</span>
                </h1>
                <p style="font-size: 25px; color: #52de97">Bulky Waste</p>
              </div>
              <div class="col-lg text-center">
                <!-- domestic waste -->
                <h1 style="font-size: 45px">
                  {{ domesticwaste }}<span style="font-size: 12px"> MT</span>
                </h1>
                <p style="font-size: 25px; color: #fc0">Domestic Waste</p>
              </div>
              <div class="col-lg text-center">
                <!-- separation at source (SAS) -->
                <h1 style="font-size: 45px">
                  {{ separationAtSource }}<span style="font-size: 12px"> MT</span>
                </h1>
                <p style="font-size: 25px; color: #3282b8">
                  Separation at Source (SAS)
                </p>
              </div>
            </div>
          </card>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-4 d-flex">
          <!-- total incoming waste tonnage received by the following collector -->
          <card>
            <template slot="header">
              <h3 class="card-title">
                <i class="tim-icons icon-paper text-info"></i>
                <b
                  >&nbsp;Total Incoming Waste Tonnage Received by The Following
                  Collector</b
                >
              </h3>
            </template>
            <br />
            <div class="row" v-for="(item, index) in wasteTonnage" :key="index">
              <div class="col-lg-8">
                <base-progress
                  class="progress-lg"
                  value-position="right"
                  :label="item.name"
                  v-model="item.percentage"
                  :type="item.type"
                ></base-progress>
              </div>
              <div class="col-lg-4 text-center">
                <img v-if="item.type == 'yellow'" src="@/assets/img/in-house.png" width="50" />
                <img v-if="item.type == 'info'" src="@/assets/img/user-trip.png" width="50" />

                <h3>
                  Total: <span>{{ item.tonnage }}</span>
                </h3>
              </div>
            </div>
            <br />
          </card>
        </div>
      
        <div class="col-lg-4 d-flex">
          <!-- total incoming vehicle by the following collectors -->
          <card>
            <template slot="header">
              <h3 class="card-title">
                <i class="tim-icons icon-paper text-info"></i>
                <b
                  >&nbsp;Total Incoming Vehicle by The Following 
                  Collectors</b
                >
              </h3>
            </template>
            <br />
            <div class="row" v-for="(item, index) in vehicle " :key="index">
              <div class="col-lg-8">
                <base-progress
                  class="progress-lg"
                  value-position="right"
                  :label="item.name"
                  v-model="item.percentage"
                  :type="item.type"
                ></base-progress>
              </div>
              <div class="col-lg-4 text-center">
                <img v-if="item.type == 'yellow'" src="@/assets/img/in-house.png" width="50" />
                <img v-if="item.type == 'info'" src="@/assets/img/user-trip.png" width="50" />

                <h3>
                  Total: <span>{{ item.tonnage }}</span>
                </h3>
              </div>
            </div>
            <br />
          
          </card>
        </div>
        <div class="col-lg-4 d-flex">
          <!-- total incoming trip by the following collectors -->
          <card>
            <template slot="header">
              <h3 class="card-title">
                <i class="tim-icons icon-paper text-info"></i>
                <b
                  >&nbsp;Total Incoming Trip by The Following 
                  Collectors</b
                >
              </h3>
            </template>
            <br />
            <div class="row" v-for="(item,index) in trip" :key="index">
              <div class="col-lg-8">
                <base-progress
                  class="progress-lg"
                  value-position="right"
                  :label="item.name"
                  v-model="item.percentage"
                  :type="item.type"
                ></base-progress>
              </div>
              <div class="col-lg-4 text-center">
                <img v-if="item.type == 'yellow'" src="@/assets/img/in-house.png" width="50" />
                <img v-if="item.type == 'info'" src="@/assets/img/user-trip.png" width="50" />

                <h3>
                  Total: <span>{{ item.tonnage }}</span>
                </h3>
              </div>
            </div>
            <br />
         
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Select, Option, DatePicker } from "element-ui";
// import RangeSlider from "vue-range-slider";
// import "vue-range-slider/dist/vue-range-slider.css";
import BaseProgress from "../../components/BaseProgress.vue";
import moment from "moment";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    // RangeSlider,
    BaseProgress,
    Loading,
  },
  data() {
    return {
      isLoading: false,
      selects: {
        site: "",
        sites: [
          {
            label: "Site A",
            value: "Site A",
          },
        ],
        collector: "",
        collectors: [
          {
            label: "Collector A",
            value: "Collector A",
          },
        ],
        time: "today",
        times: [
          {
            label: "Today",
            value: "today",
          },
          {
            label: "Daily",
            value: "daily",
          },
          {
            label: "Weekly",
            value: "weekly",
          },
          {
            label: "Monthly",
            value: "monthly",
          },
          {
            label: "Yearly",
            value: "yearly",
          },
        ],
      },
      bulkywaste: "0",
      domesticwaste: "0",
      separationAtSource: "0",
      pickerOptions: {
        shortcuts: [
          {
            text: "Last week",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Last month",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          // {
          //   text: "Last 3 months",
          //   onClick(picker) {
          //     const end = new Date();
          //     const start = new Date();
          //     start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
          //     picker.$emit("pick", [start, end]);
          //   }
          // },
          {
            text: "Last year",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      value2: "",
      totalOverallIncomingWasteTonnageReceived: "25",
      wasteTonnage: [],
      // {
      //   inHouse: 15,
      //   inHousePercent: "60",
      //   contractor: 10,
      //   contractorPercent: "40",
      // },
      vehicle: [],
      // {
      //   inHouse: 15,
      //   inHousePercent: "60",
      //   contractor: 10,
      //   contractorPercent: "40",
      // },
      trip: [],
      // {
      //   inHouse: 15,
      //   inHousePercent: "60",
      //   contractor: 10,
      //   contractorPercent: "40",
      // },
    };
  },
  created(){
   
    this.getsites()
    this.getcollectors()
    this.value2=[ moment().startOf('d'),moment().startOf('d')]
    
  },
  methods: {
    getsites(){

      this.selects.sites = []

      this.$http.get(":10001/api/v1/setting/destination").
      then(res => {
        if(!res.error){
          let response = res.message 
          console.log(response)

          for(var i=0; i<response.length; i++){
            let obj = {
              label: response[i].DestinationName,
              value: response[i].DestinationCode
            }
            this.selects.sites.push(obj)
          }

          this.selects.site = this.selects.sites[0].value
        }
      })
    },
    getcollectors(){
      this.selects.collectors = []

      this.$http.get(":10001/api/v1/setting/supplier").
      then(res => {
        if(!res.error){
          let response = res.message
          console.log(response)

          for(var i=0; i<response.length; i++){
            let obj = {
              label: response[i].SupplierName,
              value: response[i].SupplierCode
            }

            this.selects.collectors.push(obj)
          }
          this.selects.collector = this.selects.collectors[0].value

        }
      })
    },
    getOverview(){
      this.isLoading = true
      console.log( this.selects.collector, this.selects.time, this.value2)
      if(this.selects.site != '' && this.selects.collector != '' && this.selects.time != '' && this.value2 != []){

      let start = moment(this.value2[0]).format("YYYY-MM-DD")
      let end = moment(this.value2[1]).format("YYYY-MM-DD")

      
      this.$http.get(":10001/api/v1/analytics/overview?from="+start+"&to="+end+"&site-id="+this.selects.site+ "&interval=" +this.selects.time + "&collector=" + this.selects.collector).
      then(res => {
        if(!res.error){
          let response = res.message 
          console.log(response)

          this.totalOverallIncomingWasteTonnageReceived = response.TotalWeight
          this.bulkywaste = response.TotalBulkyWeight
          this.domesticwaste = response.TotalDomesticWeight
          this.separationAtSource = response.TotalSasWeight

           // array of color
           let color = ['yellow', 'info']

          // kira total incoming waste
          this.wasteTonnage = []
          let totaltonnage = 0
          for(var i=0; i<response.IncomingWasteTonnageByCollector.length; i++){
            totaltonnage += response.IncomingWasteTonnageByCollector[i].CollectorTonnage
          }
         
          for(var i=0; i<response.IncomingWasteTonnageByCollector.length; i++){
            let obj = {
              type: color[i],
              name: response.IncomingWasteTonnageByCollector[i].CollectorName,
              tonnage: response.IncomingWasteTonnageByCollector[i].CollectorTonnage,
              percentage: ((response.IncomingWasteTonnageByCollector[i].CollectorTonnage / totaltonnage) * 100).toFixed(2)
            }
            this.wasteTonnage.push(obj)
          
          }

          // kira total incoming vehicle
          this.vehicle = []
          let totalincomingvehicle = 0
          for(var i=0; i<response.IncomingVehicleByCollector.length; i++){
            totalincomingvehicle += response.IncomingVehicleByCollector[i].CollectorVehicleCount
          }
         
          for(var i=0; i<response.IncomingVehicleByCollector.length; i++){
            let obj = {
              type: color[i],
              name: response.IncomingVehicleByCollector[i].CollectorName,
              tonnage: response.IncomingVehicleByCollector[i].CollectorVehicleCount,
              percentage: ((response.IncomingVehicleByCollector[i].CollectorVehicleCount / totalincomingvehicle) * 100).toFixed(2)
            }
            this.vehicle.push(obj)
          
          }

          // kira total incoming trip
          this.trip = []
          let totalincomingtrip = 0
          for(var i=0; i<response.IncomingTripByCollector.length; i++){
            totalincomingtrip += response.IncomingTripByCollector[i].CollectorTripCount
          }
         
          for(var i=0; i<response.IncomingTripByCollector.length; i++){
            let obj = {
              type: color[i],
              name: response.IncomingTripByCollector[i].CollectorName,
              tonnage: response.IncomingTripByCollector[i].CollectorTripCount,
              percentage: ((response.IncomingTripByCollector[i].CollectorTripCount / totalincomingtrip) * 100).toFixed(2)
            }
            this.trip.push(obj)
          
          }
          this.isLoading = false
          
        }
      })
    
    }}
  },
  watch:{
    "selects.site"(){
      this.getOverview()
    },
    "selects.collector"(){
      this.getOverview()
    },
    "selects.time"(){
      this.getOverview()
    },
    value2(){
      this.getOverview()
    }
  }
};
</script>

<style scoped>
.slider {
  /* overwrite slider styles */
  width: 400px;
}
</style>
